import { render, staticRenderFns } from "./home-philosophy.vue?vue&type=template&id=e052d3ee&scoped=true"
import script from "./home-philosophy.vue?vue&type=script&lang=js"
export * from "./home-philosophy.vue?vue&type=script&lang=js"
import style0 from "./home-philosophy.vue?vue&type=style&index=0&id=e052d3ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e052d3ee",
  null
  
)

export default component.exports